<template>
<div class="content">
    <!-- 面包屑 -->
    <!-- <div class="breadcrumb">
      <i class="iconfont icondqwz"></i>
      <ul>
        <li class="active">设备管理</li>
      </ul>
    </div>-->
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
        <i class="lt"></i>
        <i class="rt"></i>
        <el-tab-pane name="jsgl">
            <span slot="label">
                <i class="iconfont iconcheck"></i>
                <i class="border"></i> 阈值维护
            </span>
            <div class="w_normalNav">
                <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
                <button class="OrangeSmBtn" @click="reset">重置</button>
                <button class="GreenSmBtn" @click="addnew">新增</button>
            </div>
            <div class="searchForm1">
                <!-- <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl"></searchForm> -->
                <el-form ref="seefrom" class="uLabelDcontent" :model="seefrom">
                    <el-form-item label="阈值名称">
                        <el-input placeholder="请输入阈值名称" v-model="seefrom.t_name"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="数据流名称:">
              <el-input placeholder="请输入数据流名称" v-model="seefrom.name"></el-input>
            </el-form-item>-->
                </el-form>
            </div>
            <div class="tableWrapper" v-loading="!showTable">
                <!-- 后端分页 -->
                <easyTable apiUrl="operation/findAllTrigger" :parent="self" :config="config" :other="other" ref="trigger">
                    <template slot="last">
                        <el-table-column prop="t_symbol" label="触发条件运算符" :formatter="stateSymbol"></el-table-column>
                    </template>
                    <template slot="last">
                        <el-table-column prop="t_condition" label="触发条件"></el-table-column>
                    </template>
                    <template slot="last">
                        <el-table-column prop="alarm_level_id" label="告警等级" :formatter="stateType"></el-table-column>
                    </template>
                    <template slot="last">
                        <el-table-column label="操作" width="300" align="center">
                            <template slot-scope="scope">
                                <el-link icon="iconfont iconedit" type="text" size="small" @click="edit(scope.$index,  scope.row)">编辑</el-link>
                                <!-- <el-link icon="iconfont iconadd" type="text" size="small">添加</el-link> -->
                                <el-link icon="iconfont icondelete" type="text" size="small" @click="deleteMsg(scope.$index,scope.row)">删除</el-link>
                                <el-link icon="iconfont iconadd" type="text" size="small" @click="tridev(scope.$index,scope.row)">关联设备</el-link>
                            </template>
                        </el-table-column>
                    </template>
                </easyTable>
            </div>
            <!-- <el-dialog class="editDialog" title="修改用户信息" :visible.sync="editDialogVisible">
          <searchForm :items="items"></searchForm>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="editDialogVisible = false">取消</el-button>
            <el-button class="confirmButton" type="primary" @click="editDialogVisible = false">确定</el-button>
          </div>
        </el-dialog>-->
            <el-dialog class="editDialog" :visible.sync="displayForm" :title="title" :close-on-click-modal="false">
                <el-form ref="addEquipment" :model="addEquipment" :rules="rules">
                    <el-form-item label="阈值名称" prop="t_name">
                        <el-input placeholder="请输入阈值名称" v-model="addEquipment.t_name"></el-input>
                    </el-form-item>
                    <el-form-item label="设备类型" prop="device_type">
                        <el-select :popper-append-to-body="false" v-model="addEquipment.device_type " value placeholder="请选择设备类型" style="width:100%" @change="changeEquipment">
                            <el-option v-for="item in optionType" :key="item.id" :label="item.typeName" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="数据流" prop="data_flag">
                        <el-select :popper-append-to-body="false" v-model="addEquipment.data_flag" placeholder="请选择数据流" style="width:100%">
                            <el-option v-for="item in options2" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="阈值符号" prop="t_symbol">
                        <el-select :popper-append-to-body="false" v-model="addEquipment.t_symbol" placeholder="请选择触发条件运算符" style="width:100%" @change="currentSel">
                            <el-option v-for="item in options" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <div v-if="condition1">
                        <el-form-item label="触发条件" prop="t_condition" ref="t_condition">
                            <el-input v-model="addEquipment.t_condition"></el-input>
                        </el-form-item>
                    </div>
                    <div v-if="condition2">
                        <el-form-item label="触发条件1" prop="t_con1" ref="t_con1">
                            <el-input v-model="addEquipment.t_con1"></el-input>
                            <!-- <el-input v-model="addEquipment.t_con2" style="width:40%"></el-input> -->
                        </el-form-item>
                        <el-form-item label="触发条件2" prop="t_con2" ref="t_con1">
                            <el-input v-model="addEquipment.t_con2"></el-input>
                            <!-- <el-input v-model="addEquipment.t_con2" style="width:40%"></el-input> -->
                        </el-form-item>
                    </div>
                    <el-form-item label="告警等级" prop="alarm_level_id">
                        <el-select :popper-append-to-body="false" v-model="addEquipment.alarm_level_id" placeholder="请选择处理类型" style="width:100%">
                            <el-option v-for="item in options3" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="告警描述" prop="remark">
                        <el-input type="textarea" v-model="addEquipment.remark"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer" v-if="seeBtn">
                    <el-button class="cancelButton" @click="displayFalse">取 消</el-button>
                    <el-button class="confirmButton" type="primary" @click="submitAdd">确 定</el-button>
                </div>
            </el-dialog>
        </el-tab-pane>
    </el-tabs>
</div>
</template>

<script>
import {
    dt,
    obj2urlsp
} from "utils";

export default {
    data() {
        return {
            rules: {
                t_name: [{
                    required: true,
                    message: "请输入阈值名称",
                    trigger: "blur"
                }, ],
                device_type: [{
                    required: true,
                    message: "请选择设备类型",
                    trigger: "change"
                }, ],
                data_flag: [{
                    required: true,
                    message: "请选择数据流",
                    trigger: "change"
                }, ],
                t_symbol: [{
                    required: true,
                    message: "请选择阈值符号",
                    trigger: "change"
                }, ],
                t_condition: [{
                    required: true,
                    message: "请输入触发条件",
                    trigger: "blur"
                }, ],
                con1: [{
                    required: true,
                    message: "请输入触发条件1",
                    trigger: "blur"
                }],
                con2: [{
                    required: true,
                    message: "请输入触发条件2",
                    trigger: "blur"
                }],
                alarm_level_id: [{
                    required: true,
                    message: "请选择告警等级",
                    trigger: "change"
                }, ],
                remark: [{
                    required: true,
                    message: "请输入告警描述",
                    trigger: "blur"
                }]
            },
            title: "",
            condition1: false,
            condition2: false,
            seeBtn: true,
            tabName: "jsgl",
            loading: true,
            form_jsgl: {},
            editDialogVisible: false,
            displayForm: false,
            showTable: true,
            other: {},
            optiontype: [],
            seefrom: {
                t_name: "",
                name: "",
            },
            options: [],
            options2: [],
            options3: [],
            optionSystem: [],
            optionType: [],
            addEquipment: {
                t_name: "",
                system_id: "",
                device_type: "",
                postbox: "",
                data_flag: "",
                t_condition: "",
                t_symbol: "",
                alarm_level_id: "",
                t_con1: "",
                t_con2: "",
                remark: ""
            },
        };
    },
    computed: {
        self() {
            return this;
        },
        config() {
            return [{
                    prop: "t_name",
                    label: "阈值名称",
                },
                {
                    prop: "name",
                    label: "数据流名称",
                },
                {
                    prop: "typeName",
                    label: "设备类型",
                },
                // {
                //   prop: (row, column) => row.oildrum.rfid_number + row.oildrum.imei,
                //   label: "随便"
                // }
            ];
        },
        dt() {
            return dt.map(({
                label
            }) => label);
        },
    },
    components: {
        normalNav: () => import("public/normalNav"),
        searchForm: () => import("public/searchForm"),
        easyTable: () => import("public/easyTable"),
    },
    methods: {
        //取消后刷新
        displayFalse() {
            this.displayForm = false;
            this.subSeefrom();
        },
        //阈值符号
        stateSymbol(row, column) {
            if (row.t_symbol === "0") {
                return ">";
            } else if (row.t_symbol === "1") {
                return "<";
            } else if (row.t_symbol === "2") {
                return "=";
            } else if (row.t_symbol === "3") {
                return "≥";
            } else if (row.t_symbol === "4") {
                return "≤";
            } else if (row.t_symbol === "5") {
                return "!=";
            } else if (row.t_symbol === "6") {
                return "in";
            } else if (row.t_symbol === "7") {
                return "out";
            } else if (row.t_symbol === "8") {
                return "change";
            } else if (row.t_symbol === "9") {
              return "equals";
            }
        },
        //告警等级
        stateType(row, column) {
            if (row.alarm_level_id === 1) {
                return "一般告警";
            } else if (row.alarm_level_id === 2) {
                return "严重告警";
            } else if (row.alarm_level_id === 0) {
                return "不告警";
            }
        },
        //初始化数据流
        changeEquipment(value) {
            this.$axiosget("manager/devicetype/dataflow", {
                params: {
                    typeId: value,
                },
            }).then((res) => {
                this.options2 = res.data.data;
            });
        },
        //搜索
        subSeefrom() {
            this.other = this.seefrom;
            this.$refs.trigger.pageToOne();
            this.$nextTick(this.$refs.trigger.getData);
        },
        //重置
        reset() {
            this.seefrom = {};
        },
        currentSel() {
            let a = this.addEquipment.t_symbol;
            if (a === "7" ? true : a === "6" ? true : false) {
                this.condition1 = false;
                this.condition2 = true;
                this.$nextTick(() => {
                    this.addEquipment.t_con1 = "";
                    this.addEquipment.t_con2 = "";
                });
            } else if (a === "8") {
                this.condition1 = false;
                this.condition2 = false;
                this.$nextTick(() => {
                    this.addEquipment.t_con1 = "";
                    this.addEquipment.t_con2 = "";
                    this.addEquipment.t_condition = "";
                });
            } else {
                this.condition1 = true;
                this.condition2 = false;
                this.$nextTick(() => {
                    this.addEquipment.t_condition = "";
                });
            }
        },
        //新增
        addnew() {
            this.title = "新增阈值信息";
            this.state = 1;
            this.displayForm = true;
            this.seeBtn = true;
            this.condition1 = false;
            this.condition2 = false;
            this.addEquipment = {
                t_name: "",
                system_id: "",
                device_type: "",
                postbox: "",
                data_flag: "",
                t_condition: "",
                t_symbol: "",
                alarm_level_id: "",
                t_con1: "",
                t_con2: "",
                remark: ''
            }
            if (this.$refs.addEquipment) {
                this.$refs.addEquipment.resetFields();
            }

        },
        //修改
        edit(index, row) {
            this.title = "修改阈值信息";
            this.displayForm = true;
            this.seeBtn = true;
            this.addEquipment = {
                t_name: row.t_name,
                system_id: row.system_id,
                device_type: row.device_type,
                postbox: row.postbox,
                data_flag: row.data_flag,
                t_condition: row.t_condition,
                t_symbol: row.t_symbol,
                alarm_level_id: row.alarm_level_id,
                t_con1: row.t_con1,
                t_con2: row.t_con2,
                remark: row.remark
            };
            this.state = 2;
            this.id = row.id;
            if ("8" === this.addEquipment.t_symbol) {
                this.condition1 = false;
                this.condition2 = false;
            } else if ("6" === this.addEquipment.t_symbol) {
                this.condition1 = false;
                this.condition2 = true;
            } else if ("7" === this.addEquipment.t_symbol) {
                this.condition1 = false;
                this.condition2 = true;
            } else {
                this.condition1 = true;
                this.condition2 = false;
            }

            this.$axiosget("manager/devicetype/dataflow", {
                params: {
                    typeId: row.device_type,
                },
            }).then((res) => {
                this.options2 = res.data.data;
            });
            this.$axiosget("operation/findTrigger", {
                params: {
                    id: row.id,
                },
            }).then((res) => {
                if (res.data.status === "10000") {
                    const cons = res.data.data.t_condition.split(",");
                    this.addEquipment.t_con1 = cons[0];
                    this.addEquipment.t_con2 = cons[1];
                    // res.data.data.t_con1 = cons[0];
                    // res.data.data.t_con2 = cons[1];
                    // Object.keys(res.data.data).forEach((item) => {
                    //   Object.keys(this.addEquipment).forEach((key) => {
                    //     if (key === item) {
                    //       this.addEquipment[key] = res.data.data[item];
                    //     }
                    //   });
                    // });
                }
            });
        },
        //确认
        submitAdd() {
            this.$refs.addEquipment.validate((valid) => {
                if (valid) {
                    if (this.state === 1) {
                        if (this.condition2) {
                            this.addEquipment.t_condition =
                                this.addEquipment.t_con1 + "," + this.addEquipment.t_con2;
                        }
                        this.$axiospost("operation/addTrigger", this.addEquipment).then(
                            (res) => {
                                if (res.data.status === "10000") {
                                    this.displayForm = false;
                                    this.subSeefrom();
                                    let loading = Loading.service({});
                                    loading.close();
                                }
                            }
                        );
                    } else if (this.state === 2) {
                        if (this.condition2) {
                            this.addEquipment.t_condition =
                                this.addEquipment.t_con1 + "," + this.addEquipment.t_con2;
                        }
                        this.$axiospost("operation/updateTrigger", {
                            id: this.id,
                            t_name: this.addEquipment.t_name,
                            data_flag: this.addEquipment.data_flag,
                            t_condition: this.addEquipment.t_condition,
                            t_symbol: this.addEquipment.t_symbol,
                            device_type: this.addEquipment.device_type,
                            alarm_level_id: this.addEquipment.alarm_level_id,
                            remark: this.addEquipment.remark
                        }).then((res) => {
                            if (res.data.status === "10000") {
                                this.displayForm = false;
                                this.subSeefrom();
                            }
                        });
                    }
                } else {
                    this.$message.error("保存失败，请输入必填项！");
                }
            });
        },
        //删除
        deleteMsg(index, row) {
            var params = new URLSearchParams();
            params.append("id", row.id);
            this.$confirm("是否删除该阈值?", "删除操作", {
                cancelButtonText: "取消",
                confirmButtonText: "确定",
                type: "warning",
            }).then(() => {
                this.$axiospost("operation/deleteTrigger", params).then((res) => {
                    if (res.data.status === "10000") {
                        this.subSeefrom();
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });
                    }
                });
            }).catch(()=>{

            })
        },
        //关联设备
        tridev(index, row) {
            this.$router.push({
                name: "tridev",
                params: {
                    id: row.id,
                    device_type: row.device_type
                },
            });
        },
    },
    created() {
        //设备类型
        this.$axiosget("manager/devicetype/getTypeByCompanyId", {
            params: {
                companyId: localStorage.getItem("companyId"),
            },
        }).then((res) => {
            this.optionType = res.data.data;
        });
        //数据流
        // this.$axiosget("manager/dataFlow/queryAllList").then(res => {
        //   //console.log(res);
        //   this.options2 = res.data.data;
        // });
        this.$axiosget("operation/device/list").then((res) => {
            if (res.data.status === "10000") {
                this.devices = res.data.data.deviceList;
            }
        });
        //告警等级
        this.$axiosget("operation/dictionaryType/queryByKey", {
            params: {
                key: 'alarmLevel',
            },
        }).then((res) => {
            if (true) {
                this.options3 = res.data.data.list;
                this.options3.forEach((item) => {
                    item.value = parseInt(item.value);
                });
            }
        });
        //阈值符号
        this.$axiosget("operation/dictionaryType/queryByKey", {
            params: {
                key: 'mathSymbol',
            },
        }).then((response) => {
            if (response.data.status === "10000") {
                this.options = response.data.data.list;
            }
        });
    },
};
</script>

<style lang="less" scoped>
.w_normalNav {
    padding-top: 10px;
    height: 52px;
    position: absolute;
    top: -52px;
    right: 32px;
    z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/device/trigger.vue